import React, {FC} from "react";
import {Container} from "../Container";
import {useMenuCollapsed} from "./MenuCollapsedContext";
import {MenuPlatform} from "./types";
import {LogoReachText, LogoSpring, LogoSpringText, PartnerPlatformLogo, ReachLogo} from "../../assets";

const LOGOS: Record<MenuPlatform, {Mark: FC; Text?: FC}> = {
  spring: {Mark: LogoSpring, Text: LogoSpringText},
  reach: {Mark: ReachLogo, Text: LogoReachText},
  partner: {Mark: PartnerPlatformLogo},
};

type MenuLogoProps = {
  platform: MenuPlatform;
};

export const MenuLogo: FC<MenuLogoProps> = ({platform}) => {
  const collapsed = useMenuCollapsed();
  const {Mark, Text} = LOGOS[platform];
  return (
    <Container
      row
      fullWidth
      sx={{
        alignItems: "flex-start",
        justifyContent: collapsed ? "center" : "flex-start",
        paddingLeft: collapsed ? "0" : "12px",
      }}
    >
      <Mark />
      {!collapsed && Text && <Text />}
    </Container>
  );
};
